/* eslint-disable no-console */
export const state = () => ({
  policies: [],
  policiesTotalCount: null,
  policiesLoading: false,
  policiesError: '',
  referFriendStatus: null,
  referFriendLoading: false,
  referFriendError: '',
  renewStripePolicyStatus: null,
  renewStripePolicyLoading: false,
  renewStripePolicyError: '',
  oldPolicies: [],
  oldPoliciesTotalCount: null,
  oldPoliciesLoading: false,
  oldPoliciesError: '',
  // TODO Uncomment if need for node api
  downloadPolicyStatus: null,
  downloadPolicyLoading: false,
  downloadPolicyError: '',
})
export const getters = {
  policies(state) {
    return state.policies
  },
  policiesTotalCount(state) {
    return state.policiesTotalCount
  },
  policiesLoading(state) {
    return state.policiesLoading
  },
  oldPolicies(state) {
    return state.oldPolicies
  },
  oldPoliciesTotalCount(state) {
    return state.oldPoliciesTotalCount
  },
  oldPoliciesLoading(state) {
    return state.oldPoliciesLoading
  },
  oldPoliciesError(state) {
    return state.oldPoliciesError
  },
  referFriendStatus(state) {
    return state.referFriendStatus
  },
  referFriendLoading(state) {
    return state.referFriendLoading
  },
  referFriendError(state) {
    return state.referFriendError
  },
  renewStripePolicyStatus(state) {
    return state.renewStripePolicyStatus
  },
  renewStripePolicyLoading(state) {
    return state.renewStripePolicyLoading
  },
  renewStripePolicyError(state) {
    return state.renewStripePolicyError
  },
  // TODO Uncomment if need for node api
  downloadPolicyStatus(state) {
    return state.downloadPolicyStatus
  },
  downloadPolicyLoading(state) {
    return state.downloadPolicyLoading
  },
  downloadPolicyError(state) {
    return state.downloadPolicyError
  },
  // notifications (state) {
  //   return (id) => {
  //     const policy = state.policies.find((policy) => {
  //       return policy.code === parseInt(id)
  //     })
  //     console.log('policy', policy)
  //     /* eslint-disable prefer-const */
  //     let warnings = []
  //     const bikes = []
  //     bikes.map((bike) => {
  //       if (!bike.serial_number) {
  //         warnings.push({
  //           bikeId: bike.dbid,
  //           type: 'serial-number',
  //           message: 'Serial number'
  //         })
  //       }
  //       if (!bike.photos.length) {
  //         warnings.push({
  //           bikeId: bike.dbid,
  //           type: 'bike-photo',
  //           message: 'Bike photo'
  //         })
  //       }
  //     })
  //     return warnings
  //   }
  // }
}
export const mutations = {
  SET_POLICIES: (state, policies) => {
    state.policies = policies
  },
  SET_POLICIES_TOTAL_COUNT: (state, policiesTotalCount) => {
    state.policiesTotalCount = policiesTotalCount
  },
  SET_POLICIES_LOADING: (state, payload) => {
    state.policiesLoading = payload
  },
  SET_POLICIES_ERROR: (state, payload) => {
    state.policiesError = payload
  },
  SET_OLD_POLICIES: (state, policies) => {
    state.oldPolicies = policies
  },
  SET_OLD_POLICIES_LOADING: (state, payload) => {
    state.oldPoliciesLoading = payload
  },
  SET_OLD_POLICIES_TOTAL_COUNT: (state, payload) => {
    state.oldPoliciesTotalCount = payload
  },
  SET_OLD_POLICIES_ERROR: (state, payload) => {
    state.oldPoliciesError = payload
  },
  REFER_FRIEND: (state, status) => {
    state.referFriendStatus = status
  },
  REFER_FRIEND_LOADING: (state, payload) => {
    state.referFriendLoading = payload
  },
  REFER_FRIEND_ERROR: (state, payload) => {
    state.referFriendError = payload
  },
  RENEW_STRIPE_POLICY_SUCCESS: (state, status) => {
    state.renewStripePolicyStatus = status
  },
  RENEW_STRIPE_POLICY_LOADING: (state, payload) => {
    state.renewStripePolicyLoading = payload
  },
  RENEW_STRIPE_POLICY_ERROR: (state, payload) => {
    state.renewStripePolicyError = payload
  },
  // TODO Uncomment if need for node api
  DOWNLOAD_POLICY: (state, policy) => {
    state.downloadPolicyStatus = policy
  },
  DOWNLOAD_POLICY_LOADING: (state, payload) => {
    state.downloadPolicyLoading = payload
  },
  DOWNLOAD_POLICY_ERROR: (state, payload) => {
    state.downloadPolicyError = payload
  },
}
export const actions = {
  async fetchPolicies({ dispatch, commit, rootGetters }, { limit, offset }) {
    const email = rootGetters['user/userEmail']
    commit('SET_POLICIES_LOADING', true)
    try {
      const { policies, totalCount } = await this.$axios.$get(
        `/api/policy/v1/policies/${email}?limit=${limit}&offset=${offset}`
      )
      commit('SET_POLICIES', policies)
      commit('SET_POLICIES_TOTAL_COUNT', totalCount)
      commit('SET_POLICIES_LOADING', false)
      commit('SET_POLICIES_ERROR', '')
    } catch (error) {
      console.log('fetch policies by email error', error)
      commit('SET_POLICIES', [])
      commit('SET_POLICIES_LOADING', false)
      commit('SET_POLICIES_ERROR', error)
    }
  },
  async fetchHistoryPolicies(
    { dispatch, commit, rootGetters },
    { limit, offset }
  ) {
    const email = rootGetters['user/userEmail']
    commit('SET_OLD_POLICIES_LOADING', true)
    try {
      const data = await this.$axios.$get(
        `/api/policy/v1/policies/history/${email}?limit=${limit}&offset=${offset}`
      )
      commit('SET_OLD_POLICIES', data.policies)
      commit('SET_OLD_POLICIES_TOTAL_COUNT', data.totalCount)
      commit('SET_OLD_POLICIES_LOADING', false)
      commit('SET_OLD_POLICIES_ERROR', '')
    } catch (error) {
      console.log('fetch policies by email error', error)
      commit('SET_OLD_POLICIES', [])
      commit('SET_OLD_POLICIES_LOADING', false)
      commit('SET_OLD_POLICIES_ERROR', error)
    }
  },
  async referFriend({ dispatch, commit }, data) {
    const { code, friends } = data
    commit('REFER_FRIEND_LOADING', true)
    try {
      const result = await this.$axios.$post(
        `/api/policy/v1/refer-friend/${code}`,
        friends
      )
      commit('REFER_FRIEND', result.success)
      commit('REFER_FRIEND_LOADING', false)
      commit('REFER_FRIEND_ERROR', '')
      this.$router.push(`/dashboard/policy/${code}`)
    } catch (error) {
      console.log('fetch policies by email error', error)
      commit('REFER_FRIEND', [])
      commit('REFER_FRIEND_LOADING', false)
      commit('REFER_FRIEND_ERROR', error)
    }
  },
  async renewStripePolicy({ dispatch, commit }, { policyCode, paymentData }) {
    commit('RENEW_STRIPE_POLICY_LOADING', true)
    try {
      const result = await this.$axios.$post(
        `/api/policy/v1/policy/${policyCode}/renew/annually`,
        { card: paymentData.cardDetails }
      )
      commit('RENEW_STRIPE_POLICY_SUCCESS', result.succes)
      commit('RENEW_STRIPE_POLICY_LOADING', false)
      commit('RENEW_STRIPE_POLICY_ERROR', '')
      this.$router.push({ path: `/`, query: { type: 'paid' } })
    } catch (error) {
      const { data } = error.response
      console.log('fetch policies by email error', data.error)
      commit('RENEW_STRIPE_POLICY_SUCCESS', [])
      commit('RENEW_STRIPE_POLICY_LOADING', false)
      commit('RENEW_STRIPE_POLICY_ERROR', data.error)
    }
  },
  async downloadPolicy({ dispatch, commit }, policyCode) {
    commit('DOWNLOAD_POLICY_LOADING', true)
    try {
      // Use full axios response with responseType blob to handle binary PDF data
      const response = await this.$axios.get(
        `/api/policy/v1/policy/${policyCode}/download`,
        {
          responseType: 'blob',
        }
      )
      // Create blob URL from the response data
      const url = window.URL.createObjectURL(response.data)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `certificate-${policyCode}.pdf`)
      document.body.appendChild(link)
      link.click()
      // Clean up the URL object
      window.URL.revokeObjectURL(url)
      document.body.removeChild(link)
      commit('DOWNLOAD_POLICY', response.data)
      commit('DOWNLOAD_POLICY_LOADING', false)
      commit('DOWNLOAD_POLICY_ERROR', '')
    } catch (error) {
      console.log('fetch policy error', error)
      commit('DOWNLOAD_POLICY', '')
      commit('DOWNLOAD_POLICY_LOADING', false)
      commit('DOWNLOAD_POLICY_ERROR', error)
    }
  },
}
